module.exports = "/wp-content/plugins/farmacy/assets/js/images/heart_filled-f156eb84f01042521d07599669ff3c37.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/common/favourite-button/img/heart_filled.png
 ** module id = 137
 ** module chunks = 1 2 3 4 5 6 7 10 11 13 16 17 22 25 26 137
 **/